import { SESSION_FETCH_OPTIONS, clearLegacySessionToken } from '@/lib/session';
import { apiUrl, BACKEND_URL } from '@/lib/apiUrl';

export function authFetch(url, options = {}) {
  if (typeof url === 'string' && url.includes('undefined')) {
    throw new Error(`Invalid API URL: ${url}`);
  }
  return fetch(url, {
    ...SESSION_FETCH_OPTIONS,
    ...options,
    credentials: 'include',
    headers: { ...(options.headers || {}) },
  }).then((res) => {
    const path = typeof url === "string" ? url : "";
    const isSessionProbe = path.includes("/api/auth/me") || path.includes("/api/auth/session");
    const isPublicPath = ["/", "/login", "/auth/callback", "/auth-test"].includes(window.location.pathname);
    if (res.status === 401 && !isSessionProbe && !isPublicPath) {
      clearLegacySessionToken();
      window.setTimeout(() => {
        if (!["/", "/login", "/auth/callback", "/auth-test"].includes(window.location.pathname)) {
          window.location.assign("/login");
        }
      }, 0);
    }
    return res;
  });
}

export function logout() {
  clearLegacySessionToken();
  return fetch(`/api/auth/logout`, {
    method: 'POST',
    ...SESSION_FETCH_OPTIONS,
  });
}

export { BACKEND_URL, apiUrl };
